import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.posts');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-posts',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.posts/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PagePostsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
    }

    public onSelect(postId: string) {
        this.service.href(`/posts/${postId}`);
    }

    public onWrite() {
        this.service.href('/posts/new');
    }
}

export default PagePostsComponent;